/* Advertorial dynamic dates — masthead date, byline, post timestamps ("posted N days ago") */
(function () {
  var DAY = 864e5, now = new Date(), age = 2; // post age in days
  function at(d, h, m) { var x = new Date(now.getTime() - d * DAY); x.setHours(h, m, 0, 0); return x; }
  function stamp(d) {
    return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric' }) +
      ' at ' + d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
  }
  var el = document.querySelector('.pub-masthead__date');
  if (el && el.getAttribute('data-auto-date') !== 'false') {
    var edition = el.getAttribute('data-edition');
    el.textContent = now.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }) +
      (edition ? ' \u00B7 ' + edition : '');
  }
  el = document.querySelector('.pub-header__byline-meta');
  if (el && el.getAttribute('data-auto-date') !== 'false') {
    var desk = el.getAttribute('data-desk');
    el.textContent = (desk ? desk + ' \u00B7 ' : '') + 'Updated ' +
      now.toLocaleDateString('en-US', { month: 'long', day: 'numeric' }) + ', ' + now.getFullYear();
  }
  var ts = document.querySelectorAll('.pub-post__timestamp');
  if (ts[0] && ts[0].getAttribute('data-auto-date') !== 'false') ts[0].textContent = stamp(at(age, 8, 14));
  if (ts[1] && ts[1].getAttribute('data-auto-date') !== 'false') ts[1].textContent = stamp(at(age + 1, 19, 32));
  for (var i = 0, rel = document.querySelectorAll('.js-rel-days'); i < rel.length; i++) rel[i].textContent = age + 'd';
})();
